import MuiTooltip from '@mui/material/Tooltip';
import type { TooltipProps } from './types';

export default function Tooltip(props: TooltipProps) {
  return <MuiTooltip arrow placement="top" {...props} />;
}
